export class RepeatsHttp {
    /**
     * Create a repeat
     * @param repeat
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async createRepeat(repeat) {
        try {
            return await window.axios.post(`repeats`, repeat);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Updates a repeat
     * @param repeat
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async updateRepeat(repeat) {
        try {
            return await window.axios.put(`repeats`, repeat);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Deletes a repeat
     * @param id
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async deleteRepeat(id) {
        try {
            return await window.axios.delete(`repeats/${id}`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Get all repeats
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async getAllRepeats() {
        try {
            return await window.axios.get(`repeats`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Get upcoming repeats
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async getUpcomingRepeats() {
        try {
            return await window.axios.get(`repeats/upcoming`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }
}
